import i18n from '../i18n';
import { api } from './client';
import type { UserBriefDto } from './types';

/** Личные контакты — см. ContactService. Направленные: видны только тому, кто добавил. */
export function listContacts(): Promise<UserBriefDto[]> {
  return api('/api/v1/contacts');
}

export function addContact(userId: string) {
  return api(`/api/v1/contacts/${userId}`, { method: 'PUT' });
}

export function removeContact(userId: string) {
  return api(`/api/v1/contacts/${userId}`, { method: 'DELETE' });
}

/** Уже в контактах или нет — для кнопки «Добавить в контакты» в инфопанели (см.
 *  ChatInfoModal); не зависит от того, отклоняли баннер в чате или нет. */
export function isContact(userId: string): Promise<boolean> {
  return api(`/api/v1/contacts/${userId}/is-contact`);
}

/** Баннер «Добавить в контакты?» в личном чате (см. ChatView) — показывать ли для этого
 *  собеседника: false, если уже в контактах или уже отклонили кнопкой «Игнорировать» ранее
 *  (на любом устройстве — состояние отказа хранится на сервере, см. ContactService). */
export function shouldPromptAddContact(userId: string): Promise<boolean> {
  return api(`/api/v1/contacts/${userId}/should-prompt`);
}

export function dismissAddContactPrompt(userId: string) {
  return api(`/api/v1/contacts/${userId}/dismiss-prompt`, { method: 'PUT' });
}

export interface ContactBirthdayDto {
  userId: string;
  displayName: string;
  birthDate: string;
}

export interface ContactLinkDto {
  clusterId: string;
  token: string;
  expiresAt: string;
}

export interface ContactLinkPreviewDto {
  userId: string;
  username: string;
  displayName: string;
  avatarFileId: string | null;
  isSelf: boolean;
  isContact: boolean;
}

interface ClientIdentityDto {
  clusterId: string;
}

export class ContactLinkOtherClusterError extends Error {
  constructor() {
    super(i18n.t('misc2:contactsOtherCluster'));
    this.name = 'ContactLinkOtherClusterError';
  }
}

/** Создать или получить собственную стабильную QR-ссылку. */
export function createOrGetMyContactLink(): Promise<ContactLinkDto> {
  return api('/api/v1/users/me/contact-link', { method: 'POST' });
}

export function resetMyContactLink(): Promise<ContactLinkDto> {
  return api('/api/v1/users/me/contact-link/reset', { method: 'POST' });
}

export function revokeMyContactLink() {
  return api('/api/v1/users/me/contact-link', { method: 'DELETE' });
}

/** Проверить clusterId до передачи token текущей установке сервера. */
export async function resolveContactLink(clusterId: string, token: string): Promise<ContactLinkPreviewDto> {
  const identity: ClientIdentityDto = await api('/api/v1/client/identity');
  if (identity.clusterId.toLowerCase() !== clusterId.toLowerCase()) {
    throw new ContactLinkOtherClusterError();
  }
  return api(`/api/v1/contacts/resolve?token=${encodeURIComponent(token)}`);
}

/** Контакты, у которых сегодня день рождения (баннер в списке чатов, см. BirthdayBanner). */
export function contactBirthdaysToday(): Promise<ContactBirthdayDto[]> {
  return api('/api/v1/contacts/birthdays-today');
}
